import { JetView, plugins } from 'webix-jet'; // Importing JetView and plugins from webix-jet
import { devConfig, endDate, startDate } from 'config/config'; // Importing configuration settings
import { perm } from 'config/config'; // Importing permissions configuration

/**
 * MenuView class extending JetView to create a sidebar menu.
 */
export default class MenuView extends JetView {
    /**
     * Configures the sidebar menu.
     * @returns {Object} Sidebar configuration object.
     */
    config() {
        var locale = this.app.getService('locale'); // Getting locale service
        locale.polyglot.onMissingKey = (a) => a; // Handling missing translation keys
        const _ = locale._; // Alias for translation function
        const theme = this.app.config.theme; // Getting theme from app config
        const screen = this.app.config.size; // Getting screen size from app config
        var perm2 = []; // Array to hold permissions

        // Event listener for menu permission updates
        webix.attachEvent('menu:Permission', (filterData) => {
            console.log('menu:Permission'); // Logging permission event
            $$('Sidebar').parse(filterData); // Parsing new filter data into sidebar
        });

        // Translating permission values
        perm.forEach(function (obj) {
            obj.value = _(obj.value); // Translating permission value
            if (obj.data != undefined) {
                obj.data.forEach(function (obj2) {
                    obj2.value = _(obj2.value); // Translating nested permission values
                });
            }
        });

        // Returning sidebar configuration
        return {
            view: 'sidebar', // Sidebar view
            id: 'Sidebar', // Sidebar ID
            css: theme, // Applying theme CSS
            position: 'left', // Sidebar position
            width: 220, // Sidebar width
            collapsed: screen !== 'wide', // Collapsing based on screen size
            scroll: true, // Enabling scroll
            data: perm, // Setting sidebar data
        };
    }

    /**
     * Initializes the sidebar with filtered permissions.
     * @param {Object} sidebar - The sidebar instance.
     */
    init(sidebar) {
        var dataNew = perm.slice(); // Creating a copy of permissions
        var total = dataNew.length; // Total number of permissions
        var cont = 0; // Counter for iteration
        const vthis = this; // Reference to the current instance

        // Filtering out permissions that should not be shown
        while (cont < total) {
            var entry = dataNew[cont]; // Current permission entry
            if (entry != undefined) {
                if (entry.show == false || entry.show == 'false') {
                    dataNew.splice(cont, 1); // Removing hidden permission
                    cont = cont - 1; // Adjusting counter after removal
                }
            }
            cont = cont + 1; // Incrementing counter
        }

        sidebar.clearAll(); // Clearing existing sidebar data
        sidebar.parse(dataNew); // Parsing filtered permissions into sidebar

        // Using Menu plugin with custom URLs
        this.use(plugins.Menu, {
            id: sidebar, // Sidebar ID
            urls: {
                customers: 'customers?user=1/information', // URL for customers
                'messages.messageList': 'messages.messageList/messages.messageInternal', // URL for messages
                'accounting.area': 'accounting.area/accounting.area_copy', // URL for accounting area
                'accounting.providers': 'accounting.providers/accounting.providers_copy', // URL for accounting providers
            },
        });

        // Event listener for menu toggle
        this.on(this.app, 'menu:toggle', () => {
            sidebar.toggle(); // Toggling sidebar visibility
            $('.reportrange input').daterangepicker(
                // Initializing date range picker
                {
                    startDate: startDate, // Setting start date
                    endDate: endDate, // Setting end date
                    ranges: {
                        // Predefined date ranges
                        Today: [moment(), moment()],
                        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last Month': [
                            moment().subtract(1, 'month').startOf('month'),
                            moment().subtract(1, 'month').endOf('month'),
                        ],
                    },
                    locale: {
                        format: 'YYYY-MM-DD', // Date format
                    },
                },
                cb, // Callback function for date selection
            );

            /**
             * Callback function for date range selection.
             * @param {Object} start - Selected start date.
             * @param {Object} end - Selected end date.
             */
            function cb(start, end) {
                devConfig.setStartDate(start); // Setting start date in devConfig
                devConfig.setEndDate(end); // Setting end date in devConfig
            }
        });
    }

    /**
     * Handles URL changes in the menu.
     * @param {Object} ui - The UI instance.
     * @param {Array} url - The URL array.
     */
    urlChange(ui, url) {
        if (!ui.find((opts) => url[1].page === opts.id).length) ui.unselect(); // Unselecting if no matching page found
    }
}

// FILE DOCUMENTED
